/* eslint-disable no-debugger */
import {
  addConfigurableComponents,
  addThousandProperties,
  fetchConfigComponents,
  fetchThousandProperties,
  getMetaSuccess,
  updatePropertyViewedFlag,
  updateSearchViewedFlag,
} from "@App/appReducer";
import Config from "@Config/index";
import { AppThunk } from "@Store/index";

const fetchHomePageData =
  (props: any): AppThunk =>
  async (dispatch, getState: any) => {
    const stateForLang = getState();

    if (__CLIENT__) {
      if (getState().router.action === "PUSH") {
        window.scrollTo(0, 0);
      }
      const state = getState();
      if (
        !state?.appData?.configComponents?.filter(
          (config: any) => config?.meta?.page === "homepage",
        ).length
      ) {
        const data = await fetchConfigComponents({ page: "homepage" });
        dispatch(addConfigurableComponents(data));
      }
      const thousandProperties = await fetchThousandProperties({
        lang: stateForLang.appData.userLanguage || "en",
        user_currency: stateForLang.appData.userCurrency,
      });
      dispatch(addThousandProperties(thousandProperties));
      return null;
    }
    const { propertyViewedFlag, searchViewedFlag } = props?.req?.cookies;
    const meta = {
      showZhDescription: Config.IS_CHINA_APP && (stateForLang.appData.userLanguage || "zh"),
      hideDefaultDescription: true,
    };

    const [data, thousandProperties] = await Promise.all([
      fetchConfigComponents({ page: "homepage" }),
      fetchThousandProperties({
        lang: stateForLang.appData.userLanguage || "en",
        user_currency: stateForLang.appData.userCurrency,
      }),
    ]);
    dispatch(addConfigurableComponents(data));
    dispatch(addThousandProperties(thousandProperties));
    return (
      dispatch(updateSearchViewedFlag(searchViewedFlag === "true")),
      dispatch(updatePropertyViewedFlag(propertyViewedFlag === "true")),
      // @ts-ignore
      dispatch(getMetaSuccess(meta))
    );
  };

export default fetchHomePageData;
